import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Search, Heart, User } from "lucide-react";
import { ShoppingBag } from "lucide-react";
import { useStore } from "../../context/StoreContext";

export default function MobileNav() {
  const { pathname } = useLocation();
  const { user, cartCount, setCartOpen } = useStore();
  const items = [
    { icon: Home, label: "Home", to: "/" },
    { icon: Search, label: "Shop", to: "/shop" },
    { icon: ShoppingBag, label: "Cart", action: () => setCartOpen(true), badge: cartCount },
    { icon: Heart, label: "Wishlist", to: "/wishlist" },
    { icon: User, label: "Account", to: user ? "/account" : "/login" },
  ];
  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-ivory/95 backdrop-blur-xl border-t border-sage/30">
      <div className="grid grid-cols-5">
        {items.map((it) => {
          const active = it.to && (it.to === "/" ? pathname === "/" : pathname.startsWith(it.to));
          const Cmp = it.to ? Link : "button";
          return (
            <Cmp key={it.label} to={it.to} onClick={it.action} data-testid={`bottomnav-${it.label.toLowerCase()}`}
              className={`relative flex flex-col items-center gap-1 py-2.5 ${active ? "text-forest" : "text-forest/45"}`}>
              <it.icon size={19} strokeWidth={1.5} />
              <span className="text-[10px] tracking-wide">{it.label}</span>
              {it.badge > 0 && <span className="absolute top-1 right-1/2 translate-x-4 bg-forest text-ivory text-[8px] h-4 w-4 flex items-center justify-center rounded-full">{it.badge}</span>}
            </Cmp>
          );
        })}
      </div>
    </nav>
  );
}
